import React, { useEffect } from "react";
import { Box, Divider } from "@material-ui/core";
import { IntroText, ButtonLoader } from "../../../components";
import { useHeader } from "../../../contexts";
import { useTranslation } from "react-i18next";

const ScheduleEthnicity = ({ updateScheduleData, isSubmitting }) => {
  const { t } = useTranslation();
  const { setTitle } = useHeader();

  useEffect(() => {
    setTitle(t("schedule.ethnicity.title"));
  }, []);

  const handleChange = ethnicity => {
    updateScheduleData({ ethnicity });
  };

  return (
    <Box data-cy="schedule-screen-ethnicity">
      <IntroText>{t("schedule.ethnicity.intro_text")}</IntroText>
      <ButtonLoader
        variant="contained"
        color="primary"
        fullWidth
        size="large"
        data-cy="ethnicity-hispanic-latino-spanish"
        onClick={e => handleChange("hispanic_latino_spanish")}
        loading={isSubmitting}
      >
        {t("schedule.ethnicity.options.yes")}
      </ButtonLoader>
      <Box my={2}>
        <Divider variant="middle" />
      </Box>
      <ButtonLoader
        variant="contained"
        color="default"
        fullWidth
        size="large"
        data-cy="ethnicity-not-specified"
        onClick={e => handleChange("")}
        loading={isSubmitting}
      >
        {t("schedule.ethnicity.options.no")}
      </ButtonLoader>
    </Box>
  );
};

export { ScheduleEthnicity };
